import React from "react";
import { connect } from "react-redux";
import { Modal, Button, Row } from "react-bootstrap";
import { alertActions } from "../../../../store/actions/AlertActions";
import { deleteDocument } from "../../../../services/RequestService";
//import "../../../pages/settings/process/SettingsProcessPage.css";
import { Col } from "react-bootstrap";

function ModalDocumentDelete({ show, onHide, document, onAddAlert }) {
  const [loading, setLoading] = React.useState(false);

  function confirmRemove() {
    setLoading(true);
    deleteDocument({ deleteId: document.id })
      .then((res) => {
        console.log(res);
        if (res.ok) {
          onAddAlert("Documento removido com sucesso.", "success");
          onHide(true);
        } else {
          onAddAlert(res.data.log, "danger");
          onHide(true);
        }
      })
      .catch((e) => {
        onAddAlert("Ocorreu um erro ao tentar remover o documento.", "danger");
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Remoção de Documento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Você tem certeza que deseja excluir o Documento: {document.name}?</p>
      </Modal.Body>
      <Modal.Footer className="p-0">
        <Row className="w-100 m-0">
          <Col className=" p-0">
            <Button
              variant="secondary"
              className="w-100 button-without-rounded"
              onClick={() => onHide()}
            >
              Voltar
            </Button>
          </Col>
          <Col className="p-0">
            <Button
              variant="danger"
              className="w-100 button-without-rounded"
              disabled={loading}
              onClick={confirmRemove}
            >
              Remover
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddAlert: (text, document, alertPriority) =>
      dispatch(alertActions.addAlert(text, document, alertPriority)),
  };
};

export default connect(null, mapDispatchToProps)(ModalDocumentDelete);
